<template>
  <v-app>
    <component :is="layout">
      <router-view/>
    </component>
    <v-snackbar
      :value="snackbar"
      :timeout="-1"
      color="rgba(0, 0, 0, 0.75)"
    >
      {{ snackbarText }}
    </v-snackbar>

    <v-snackbar
      bottom
      right
      :value="updateExists"
      :timeout="-1"
      color="primary">
      {{$t('pwa.updateAwailable')}}
      <v-btn text @click="refreshApp">
        {{$t('pwa.update')}}
      </v-btn>
    </v-snackbar>
  </v-app>
</template>


<script>
import { mapState } from 'vuex'

import themeMixin from '@/mixins/theme.mixin'
import pUpdateMixin from '@/mixins/pUpdate.mixin'


export default {
  name: 'App',


  mixins: [
    themeMixin,
    pUpdateMixin
  ],


  computed: {
    ...mapState('snackbar', ['snackbar', 'snackbarText']),

    layout () {
      return this.$route.meta.layout || 'default-layout'
    }
  }
}
</script>


<style lang="scss">
  @import '@/styles/main.scss';
</style>
